import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import * as moment from 'moment';
import {Moment} from 'moment';
import {User} from '@app/core/models/user.model';
import {IQODropDownAction} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-drop-down-action.interface';

export class DayNote extends BaseModel {
	public id: number;
	public note: string;
	public hidden_note: boolean;
	public created_at: Moment;
	public updated_at: Moment;
	public start: Moment;
	public end: Moment;
	public user: User;
	public actions: IQODropDownAction<DayNote>[];

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		this.start = moment(input.start);
		this.end = moment(input.end);
		this.updated_at = moment(input.updated_at);
		this.created_at = moment(input.created_at);
		if (input.user) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}

		return this;
	}
}
